export const siteSettings = {
  name: "Hexa Capital Pro",
  link: "https://hexacapitalpro.com",
  email: "support@hexacapitalpro.com",
  appLink: "https://app.hexacapitalpro.com",
};
